import React, {useState, useEffect} from 'react';
import Pane from "../../../Components/Pane";
import PageLoadingPanel from "../../../Components/PageLoadingPanel";
import ProgressBar from "../../../Components/ProgressBar";
import PrimaryTitle from "../../../Components/PrimaryTitle";
import Text from "../../../Components/Text";
import FormInput from "../../../Components/Forms/FormInput";
import InvisiblePane from "../../../Components/InvisiblePane";
import BackButton from "../../../Components/BackButton";
import {JOURNEYS, prependJourneyToRouteName} from "../../../constants";
import Button from "../../../Components/Button";
import AgentPanel from "../../../Components/AgentPanel";
import {default as ErrorMessage} from "../../../Components/Error";

const MangoStripeSubscriptionPage = (props) => {
    const {
        previousPage    = () => {},
        nextPage        = () => {},
        journey         = JOURNEYS.MANGO,
    } = props;

    const PAGE_TITLE            = 'Subscription';
    const CURRENT_STEP_NUMBER   = 3;
    const TOTAL_STEP_NUMBER     = 4;

    const [loaded, setLoaded] = useState(false);

    let url = route('payment.session.payment', {session: window.session}).toString();

    useEffect(() => {
        getStatus();

        window.addEventListener('beforeunload', preventMangoNavigation);
        return () => {
            window.removeEventListener('beforeunload', preventMangoNavigation);
        }
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            getStatus();
        }, 1000 * 10);
        return () => clearInterval(interval);
    }, []);

    const getStatus = () => {
        axios.get(route(prependJourneyToRouteName(journey, 'session.stripe-subscription.status'), {session: window.session}).toString())
            .then((response) => {
                if (!!response && !!response.data && !!response.data.payment_completed) {
                    nextPage();
                }
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
                setLoaded(true);
            });
    }

    const preventMangoNavigation = (event) => {
        event.preventDefault()
        event.returnValue = ''
    }

    const handleCopy = () => {
        // Copy the text inside the text field
        navigator.clipboard.writeText(url).then(function() {
            alert("Customer payment URL has been copied to the clipboard.");
        }, function(err) {
            alert("Copy override does not work in your browser.");
        });

    }

    if (!loaded) {
        return (
            <PageLoadingPanel
                pageTitle={PAGE_TITLE}
                currentStepNumber={CURRENT_STEP_NUMBER}
                totalStepNumber={TOTAL_STEP_NUMBER}
                upperTextComponent={null}
            />
        )
    }

    return (
        <React.Fragment>
            <ErrorMessage message={["Changing from this page can cause system problems.", "This page will redirect when payment is complete."]} />
            <Pane>
                <ProgressBar
                    title={PAGE_TITLE}
                    currentStepNumber={CURRENT_STEP_NUMBER}
                    totalStepNumber={TOTAL_STEP_NUMBER}
                />
                <PrimaryTitle>{PAGE_TITLE}</PrimaryTitle>
                <Text>Copy the link below to send to the customer:</Text>
                <div style={{marginBottom: '21px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                    <FormInput
                        name={'payment_link'}
                        label={'Payment Link'}
                        value={url}
                        type={'text'}
                        onChange={(value) => {}}
                        disabled={true}
                    />
                    <Button
                        label={'Copy'}
                        onClick={() => handleCopy()}
                        style={{
                            marginTop: '12px',
                            marginLeft: '11px',
                            width: '25%',
                            minWidth: '100px',
                            background: 'transparent',
                            border: '1px solid #2d3047',
                            color: '#2d3047',
                            minHeight: 'auto',
                            padding: '10px',
                            boxShadow: 'none'
                        }}
                    />
                </div>

                <Text>This page will refresh every 10 seconds to check for a complete payment.</Text>
            </Pane>
            <InvisiblePane style={{paddingTop: '80px', paddingLeft: 0, paddingRight: 0, display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                <BackButton onClick={() => previousPage()} />
            </InvisiblePane>
            <AgentPanel journey={journey} />
        </React.Fragment>
    );
}

export default MangoStripeSubscriptionPage;
